exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-desafio[data-v-06d8fe9a]{border-radius:15px!important;border:0!important;align-items:center;transition:.2s;z-index:0;margin:10px;width:150px}.card-desafio[data-v-06d8fe9a]:hover{box-shadow:-1px 11px 16px 1px rgba(0,0,0,.32);transition:.2s;transform:scaleX(1.05) scaleY(1.05);z-index:1}.card-desafio-image[data-v-06d8fe9a]{border-radius:10px;width:150px}@media screen and (max-width:600px){.card-desafio[data-v-06d8fe9a]{width:100px;margin:10px}.card-desafio-image[data-v-06d8fe9a]{border-radius:10px;width:100px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06d8fe9a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/challenges/Challenge.vue
// module id = 446
// module chunks = 0